
import { Component, Mixins } from "vue-property-decorator";
import { ICategoryNamePropertyEditable, instanceOfICategoryNamePropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class CategoryNamePropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: ICategoryNamePropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ICategoryNamePropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isCategoryNameEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfICategoryNamePropertyEditable(s) && s.categoryName().isEditable(), false);
  }

  get categoryName(): string {
    return this.readPropertyOrDefault(s => s.categoryName().getValue(), "");
  }

  set categoryName(value: string) {
    this.writePropertyWhenValid(s => s.categoryName().setValue(value));
  }
}
